import FeedbackLayout from "./pages/FeebackLayout.vue";
import FeedbackReportPage from "./pages/FeedbackReportPage.vue"

export const feedbackRoutes = {
  path: "feedback",
  component: FeedbackLayout,
  redirect: {
    name: 'FeedbackReportPage'
  },
  children: [
    {
      name: "FeedbackReportPage",
      path: "",
      component: FeedbackReportPage
    }
  ]
};



// WEBPACK FOOTER //
// ./src/features/feedbacks/routes.js